module.exports = __webpack_public_path__ + "img/store_d.ca3076bf.svg";